import axiosInstance from '../api';
import { GetAllHospitalsRes } from './hospitalApi.types';

/**
 * 全ての病院情報を取得する
 * @returns 病院リスト
 */
export const fetchHospitals = async (): Promise<GetAllHospitalsRes> => {
  try {
    const response = await axiosInstance.get<GetAllHospitalsRes>('/hospitals');
    return response.data;
  } catch (error) {
    console.error('病院情報の取得に失敗:', error);
    throw error;
  }
}; 